//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
//销售退换货列表页面
const overviewList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/salesReturnsAndExchanges/overviewList.vue')),
    'overviewList'
  );
//销售退货创建页面
const returnAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/salesReturnsAndExchanges/add.vue')),
    'returnAdd'
  );
//销售换货创建页面
const changeAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/salesReturnsAndExchanges/returnAdd.vue')),
    'changeAdd'
  );
//销售退货修改页面
const returnEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/salesReturnsAndExchanges/edit.vue')),
    'returnEdit'
  );
//销售换货修改页面
const changeEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/salesReturnsAndExchanges/returnAdd.vue')),
    'changeEdit'
  );

const salesReturnRouter = {
  path: '/salesReturnAndExchange',
  component: index,
  children: [
    {
      path: 'overviewList',
      name: 'overviewList',
      component: overviewList,
      meta: {
        keepAlive: true,
        title: '销售退换货列表',
      },
    },
    {
      path: 'returnAdd',
      name: 'returnAdd',
      component: returnAdd,
      meta: {
        keepAlive: true,
        title: '销售退货单创建',
      },
    },
    {
      path: 'returnEdit',
      name: 'returnEdit',
      component: returnEdit,
      meta: {
        keepAlive: true,
        title: '销售退货单编辑',
      },
    },
    {
      path: 'changeAdd',
      name: 'changeAdd',
      component: changeAdd,
      meta: {
        keepAlive: true,
        title: '销售换货单创建',
      },
    },
    {
      path: 'changeEdit',
      name: 'changeEdit',
      component: changeEdit,
      meta: {
        keepAlive: true,
        title: '销售换货单编辑',
      },
    },
  ],
};
export default salesReturnRouter;
